var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn",class:_vm.cssClass,attrs:{"type":"button","title":_vm.title,"data-clipboard-text":_vm.text,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement}},[_c('i',{staticClass:"fa fa-clipboard",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceaea0ee","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/clipboard_button.vue
// module id = null
// module chunks = 